import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { CaretDown, Check } from "@phosphor-icons/react";

// Searchable dropdown for inventory items — Command inside a Popover.
// props: items (array), value (item_id), onChange (item_id) => void, disabled
export default function ItemPicker({ items, value, onChange, disabled = false, testid }) {
  const [open, setOpen] = useState(false);
  const selected = items.find((i) => i.item_id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          disabled={disabled}
          className="w-full justify-between font-normal"
          data-testid={testid}
        >
          <span className={selected ? "truncate" : "text-muted-foreground truncate"}>
            {selected ? `${selected.code} — ${selected.name}` : "Select item"}
          </span>
          <CaretDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[380px]" align="start">
        <Command>
          <CommandInput placeholder="Search code, name, category…" />
          <CommandList>
            <CommandEmpty>No items found.</CommandEmpty>
            <CommandGroup>
              {items.map((i) => (
                <CommandItem
                  key={i.item_id}
                  value={`${i.code} ${i.name} ${i.category || ""}`}
                  onSelect={() => {
                    onChange(i.item_id);
                    setOpen(false);
                  }}
                >
                  <Check size={14} className={`mr-2 ${value === i.item_id ? "opacity-100" : "opacity-0"}`} />
                  <div className="flex flex-col">
                    <span className="font-medium">
                      <code className="text-[11px] mr-1">{i.code}</code>
                      {i.name}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {i.category || "—"} · Stock {i.opening_stock} {i.unit}
                    </span>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
